import { defineStore } from 'pinia'
import { useManagementCatalogStore } from './managementCatalog'

export const TWO_FA_STATUS = {
  NO_REQUIRED: 'NO_REQUIRED',
  REQUIRES_SETUP: 'REQUIRES_SETUP',
  SETUP: 'SETUP',
  VALIDATED: 'VALIDATED'
}
export const useAuthStore = defineStore('authStore', {
  state: () => ({
    isAuthenticated: false,
    twoFAStatus: TWO_FA_STATUS.NO_REQUIRED,
  }),
  actions: {
    setAuth() {
      this.isAuthenticated = true;
    },
    setTwoFAStatus(status) {
      if (Object.values(TWO_FA_STATUS).includes(status)) {
        this.twoFAStatus = status;
      } else {
        console.error(`Estado de 2FA inválido: ${status}`);
      }
    },
    logout() {
      useManagementCatalogStore().clear();
      // Reset all state variables on logout
      this.isAuthenticated = false;
      this.twoFAStatus = TWO_FA_STATUS.NO_REQUIRED;
      // Remove persisted state from localStorage
      localStorage.removeItem('TIPO');
      localStorage.removeItem('TOKEN');
      localStorage.removeItem('DESPACHO');
      localStorage.removeItem('USERNAME');
      localStorage.removeItem('NAME');
      localStorage.removeItem('LAST_NAME');
      localStorage.removeItem('ID');
      localStorage.removeItem('PERMISOS');
      localStorage.removeItem('TIPO_CARTERA');
    }
  },
  persist: true // Requires pinia-plugin-persistedstate
})
